export default __webpack_public_path__ + "static/media/logo.2815d815.png";